var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view_password") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#565656",
    d: "M15.657 16c0 1.458 0.577 2.856 1.605 3.887s2.422 1.61 3.875 1.61c1.454 0 2.848-0.579 3.875-1.61s1.605-2.429 1.605-3.887c0-1.458-0.577-2.856-1.605-3.887s-2.422-1.61-3.875-1.61c-1.453 0-2.847 0.579-3.875 1.61s-1.605 2.429-1.605 3.887zM42.384 14.734c-4.639-9.801-11.651-14.734-21.051-14.734-9.405 0-16.412 4.933-21.051 14.739-0.186 0.395-0.283 0.827-0.283 1.264s0.097 0.869 0.283 1.264c4.639 9.801 11.651 14.734 21.051 14.734 9.405 0 16.412-4.933 21.051-14.739 0.377-0.795 0.377-1.718 0-2.528zM21.138 24.638c-4.756 0-8.612-3.867-8.612-8.638s3.856-8.638 8.612-8.638c4.756 0 8.612 3.867 8.612 8.638s-3.856 8.638-8.612 8.638z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPassword);
export default __webpack_public_path__ + "static/media/view_password.a4a743dc433e4b1128d8a221e9274ef1.svg";
export { ForwardRef as ReactComponent };